/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetScreenbugByDateQueryResponse, PntSegmentsControllerGetScreenbugByDatePathParams, PntSegmentsControllerGetScreenbugByDateQueryParams } from "../models/PntSegmentsControllerGetScreenbugByDate";

export function getPntSegmentsControllerGetScreenbugByDateUrl(slug: PntSegmentsControllerGetScreenbugByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/screenbug` as const }
  return res
}

/**
 * @summary Retrieve the screenbugs for a given time range
 * {@link /pnt/v2/segments/:slug/screenbug}
 */
export async function pntSegmentsControllerGetScreenbugByDate(slug: PntSegmentsControllerGetScreenbugByDatePathParams["slug"], params: PntSegmentsControllerGetScreenbugByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntSegmentsControllerGetScreenbugByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntSegmentsControllerGetScreenbugByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}